import { SxProps } from '@mui/material';

export const checkCircleBoxContainerSx = ({ isMobile }: { isMobile: boolean }): SxProps => ({
	position: 'relative',
	bottom: isMobile ? 10 : 12,
	left: isMobile ? 10 : 17,
	width: isMobile ? 15 : 23,
	height: isMobile ? 15 : 23,
	borderRadius: '50%',
	backgroundColor: 'white',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const checkCircleBoxIconSx = ({ isMobile }: { isMobile: boolean }): SxProps => ({
	borderRadius: '50%',
	fontSize: isMobile ? 14 : 20,
});
